var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFileBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2H13.6161C13.9476 2 14.2656 2.1317 14.5 2.36612L19.1339 7C19.3683 7.23442 19.5 7.55236 19.5 7.88388V13.25H4.5V4.5C4.5 3.11929 5.61929 2 7 2ZM13.875 3.875V6.375C13.875 7.06536 14.4346 7.625 15.125 7.625H17.625L13.875 3.875Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17H19.5V19.5C19.5 20.8807 18.3807 22 17 22H7C5.61929 22 4.5 20.8807 4.5 19.5V17Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 14.5C2.27982 14.5 2 14.7798 2 15.125C2 15.4702 2.27982 15.75 2.625 15.75H21.375C21.7202 15.75 22 15.4702 22 15.125C22 14.7798 21.7202 14.5 21.375 14.5H2.625Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFileBreak);
export default __webpack_public_path__ + "static/media/ico-file-break.45e4dd452bb0a23229d6e583b7aec19f.svg";
export { ForwardRef as ReactComponent };